import { render, staticRenderFns } from "./InvoicesDetailsModal.vue?vue&type=template&id=711f48df&"
import script from "./InvoicesDetailsModal.vue?vue&type=script&lang=js&"
export * from "./InvoicesDetailsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "InvoicesDetailsModal.vue"
export default component.exports